import { excelExports } from '../../../../../constants/exportsExcel';
import { getMunicipalityExportItems } from '../../../../../utilities/getMunicipalityExports';

export const getExcelExportItems = (
  municipality,
  translator,
  downloadReport,
  canDownloadReport,
  canDownloadUserReport,
  canDownloadHearingResponseReport,
  buttonStyles,
) => {
  const exports = excelExports(
    translator,
    downloadReport,
    canDownloadReport,
    canDownloadUserReport,
    canDownloadHearingResponseReport,
    buttonStyles,
  );

  return getMunicipalityExportItems(exports, municipality);
};
